import { IconProps } from "./types";

const ChevronDown = ({ ...props }: IconProps) => {
    return (
        <svg width="13" height="12" viewBox="0 0 13 12" fill="none" {...props}>
            <g clipPath="url(#clip0_1151_16130)">
                <rect x="0.167969" width="12" height="12" rx="6" fill="#100069" />
                <path
                    d="M7.81871 4.91582C7.8866 4.8415 7.97828 4.7998 8.07382 4.7998C8.16936 4.7998 8.26104 4.8415 8.32893 4.91582C8.36245 4.95232 8.38907 4.99582 8.40724 5.0438C8.42541 5.09178 8.43477 5.14328 8.43477 5.19529C8.43477 5.24731 8.42541 5.2988 8.40724 5.34678C8.38907 5.39476 8.36245 5.43826 8.32893 5.47476L6.29014 7.68397C6.22209 7.75819 6.13035 7.79981 6.03477 7.79981C5.93918 7.79981 5.84744 7.75819 5.77939 7.68397L3.7406 5.47476C3.70708 5.43826 3.68046 5.39476 3.66229 5.34678C3.64412 5.2988 3.63477 5.24731 3.63477 5.19529C3.63477 5.14328 3.64412 5.09178 3.66229 5.0438C3.68046 4.99582 3.70708 4.95232 3.7406 4.91582C3.80849 4.8415 3.90017 4.7998 3.99571 4.7998C4.09125 4.7998 4.18293 4.8415 4.25082 4.91582L6.03555 6.72761L7.81871 4.91582Z"
                    fill="#F6F5FA"
                />
            </g>
            <defs>
                <clipPath id="clip0_1151_16130">
                    <rect width="12" height="12" fill="white" transform="translate(12.168 12) rotate(180)" />
                </clipPath>
            </defs>
        </svg>
    );
};

export default ChevronDown;
